export const CONTACT_PHONE = "011-47593526";
export const CONTACT_PHONE_TEL = "+911147593526";
export const WHATSAPP_NUMBER = "918076839130";
export const WHATSAPP_DISPLAY = "8076839130";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const CONTACT_EMAIL = "support@emicrontech.com";
export const SALES_EMAIL = "info@emicrontech.com";
export const HR_EMAIL = "hr@emicrontech.com";
export const MAIL_CC = "vijay.kumar@emicrontech.com, Pankaj.kumar@emicrontech.com";
export const SOCIAL_LINKEDIN_URL = "https://www.linkedin.com/company/emicron-techsolutions-pvt-ltd";
export const SOCIAL_X_URL = "https://x.com/EmicronTech";
export const SOCIAL_FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61563288885309";
export const SOCIAL_INSTAGRAM_URL = "https://www.instagram.com/emicrontechsolutions/";

export const OFFICE_ADDRESSES = [
  {
    id: "delhi",
    label: "Delhi Office",
    lines: [
      "Emicron Techsolutions Pvt Ltd.",
      "D-132, Pocket D, Phase 1 Industrial Area,",
      "Okhla, New Delhi, Delhi 110020",
    ],
    mapsQuery: "D-132, Pocket D, Phase 1 Industrial Area, Okhla, New Delhi, Delhi 110020",
    mapsUrl: "https://maps.app.goo.gl/dANFLb2iwL1EA5Y6A?g_st=ic",
    mapsFtid: "0x390ce14ec127c61b:0xa207152adfcdd469",
  },
  {
    id: "mumbai",
    label: "Mumbai Office",
    lines: [
      "Emicron Techsolutions Pvt Ltd,",
      "Resource Workspaces, Ujagar Chambers Prem. Co-op Soc Ltd.,",
      "Deonar, Chembur East, Mumbai-400088",
    ],
    mapsQuery: "Resource Workspaces Ujagar Chambers Deonar Chembur East Mumbai 400088",
  },
];

export function officeMapsUrl(office) {
  if (office.mapsUrl) return office.mapsUrl;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(office.mapsQuery)}`;
}

export function officeMapsEmbedUrl(office) {
  const query = encodeURIComponent(office.mapsQuery);
  const ftid = office.mapsFtid ? `&ftid=${office.mapsFtid}` : "";
  return `https://maps.google.com/maps?q=${query}${ftid}&z=17&output=embed`;
}

// Feature flags
export const SHOW_TECHNOLOGY_PARTNERS = false;

export const services = [
  {
    slug: "cloud-solution",
    icon: "bi-cloud-fill",
    title: "Cloud Service",
    desc: "Maximize your cloud investments with our CloudOps services. We ensure efficient management, scalability, and cost-effectiveness for your cloud infrastructure.",
    longDesc: "Maximize your cloud investments with our CloudOps services. We ensure efficient management, scalability, and cost-effectiveness for your cloud infrastructure.",
    subtitle: "Maximize your cloud investments with our CloudOps services.",
    introParagraphs: [
      "Maximize your cloud investments with our CloudOps services. We ensure efficient management, scalability, and cost-effectiveness for your cloud infrastructure.",
      "From cloud migration to ongoing optimization, we help you build secure, scalable environments on Azure, AWS, Google Cloud, and hybrid platforms.",
    ],
    features: [
      { icon: "bi-cloud-arrow-down", title: "Cloud Storage", desc: "Store your data securely in the cloud with scalable and reliable cloud storage solutions tailored to meet your business needs." },
      { icon: "bi-server", title: "Cloud Servers", desc: "Deploy and manage virtual servers in the cloud for flexible, scalable, and cost-effective hosting of your applications and services." },
      { icon: "bi-database", title: "Cloud Database Management", desc: "Streamline your data operations with cloud-based database management, ensuring high availability, security, and reliability." },
      { icon: "bi-gear-wide-connected", title: "Cloud Automation", desc: "Automate and optimize your cloud processes with our cloud automation solutions, ensuring efficiency and consistency across operations." },
      { icon: "bi-graph-up-arrow", title: "Cloud Analytics", desc: "Leverage cloud analytics to gain actionable insights from your data, helping you make informed decisions and drive business growth." },
      { icon: "bi-shield-lock", title: "Cloud Security", desc: "Protect your cloud infrastructure and data with robust cloud security solutions, including encryption, firewalls, and threat detection." },
    ],
    commitmentTitle: "Our Commitment to Delivering Reliable and Scalable Cloud Solutions",
    commitmentItems: [
      { title: "Experienced Cloud Professionals", desc: "Our team of certified experts brings years of cloud deployment experience for your success." },
      { title: "Best Practices & Tools", desc: "Leverage proven methodologies, tools, and frameworks to ensure seamless cloud operations." },
      { title: "Advanced Security", desc: "Implement rigorous security measures, encryption, and compliance for data protection." },
      { title: "Continuous Monitoring", desc: "Proactive monitoring to resolve issues quickly and keep your cloud infrastructure healthy." },
      { title: "24/7 Support", desc: "Get round-the-clock support from our team to address any cloud-related queries or challenges." },
      { title: "Scalable Cloud Solutions", desc: "Scale your cloud infrastructure effortlessly to meet growing business demands." },
    ],
    image: "cloud-services.png",
  },
  {
    slug: "storage-virtualization",
    icon: "bi-server",
    title: "Datacentre & Virtualization",
    desc: "Modernize your infrastructure with our data centre and virtualization expertise. We design, implement, and manage scalable, high-performance environments tailored to your business needs.",
    longDesc: "Modernize your infrastructure with our data centre and virtualization expertise. We design, implement, and manage scalable, high-performance environments tailored to your business needs.",
    subtitle: "Modernize your infrastructure with data centre and virtualization expertise.",
    introParagraphs: [
      "Modernize your infrastructure with our data centre and virtualization expertise. We design, implement, and manage scalable, high-performance environments tailored to your business needs.",
      "From strategic design to ongoing maintenance, we ensure the seamless operation of your critical technology foundation.",
    ],
    features: [
      { icon: "bi-hdd-stack", title: "Enterprise Storage", desc: "We deliver expert storage system integration, handling everything from needs assessment and design to implementation and support." },
      { icon: "bi-diagram-3", title: "Server Virtualization", desc: "We offer professional server virtualization integration, specializing in VMware and Hyper-V." },
      { icon: "bi-display", title: "Virtual Desktop Infrastructure (VDI)", desc: "We provide and integrate VDI solutions, delivering end-to-end services for seamless virtual desktop deployment." },
      { icon: "bi-building", title: "Data Center Infrastructure", desc: "We specialize in data center infrastructure integration, offering complete solutions from design to deployment." },
      { icon: "bi-cloud-arrow-up", title: "Cloud Integration and Hybrid Solutions", desc: "We provide comprehensive cloud integration and hybrid cloud solutions for flexible, scalable infrastructure." },
      { icon: "bi-gear-wide-connected", title: "Infrastructure Automation", desc: "We deliver expert infrastructure automation integration services to streamline IT operations." },
      { icon: "bi-arrow-repeat", title: "Backup and Disaster Recovery", desc: "We provide and integrate comprehensive backup and disaster recovery solutions, offering complete protection for your data." },
    ],
    commitmentTitle: "Our Commitment to Delivering Reliable, Secure, and High-Performance Infrastructure",
    commitmentItems: [
      { title: "Proven Expertise", desc: "A demonstrated history of successful enterprise infrastructure implementations and satisfied clients." },
      { title: "Industry Best Practices", desc: "Adherence to industry-leading methodologies for design, deployment, and management." },
      { title: "Performance & Reliability Assurance", desc: "Rigorous testing and validation to ensure optimal performance, reliability, and security." },
      { title: "Proactive Support & Monitoring", desc: "Continuous monitoring and dedicated support to address potential issues and maximize uptime." },
    ],
    image: "datacentre-virtualisation.png",
  },
  {
    slug: "cybersecurity-solution",
    icon: "bi-shield-lock",
    title: "Network and Security Services",
    desc: "Protect your business from evolving cyber threats. Our security solutions include assessments, threat detection, and mitigation strategies to safeguard your data.",
    longDesc: "Protect your business from evolving cyber threats. Our security solutions include assessments, threat detection, and mitigation strategies to safeguard your data.",
    subtitle: "Protect your business from evolving cyber threats.",
    introParagraphs: [
      "Protect your business from evolving cyber threats. Our security solutions include assessments, threat detection, and mitigation strategies to safeguard your data.",
      "We combine network security and cybersecurity expertise to deliver multi-layered protection across your infrastructure, endpoints, and cloud environments.",
    ],
    features: [
      { icon: "bi-database-lock", title: "Data Security", desc: "Protect sensitive data with encryption, access controls, and breach prevention measures." },
      { icon: "bi-laptop", title: "Endpoint Security", desc: "Safeguard devices from malware, ransomware, and phishing attacks." },
      { icon: "bi-shield-check", title: "Network Security", desc: "Implement firewalls, intrusion detection systems, and secure VPNs." },
      { icon: "bi-lightning-charge", title: "Incident Response", desc: "Rapidly detect and respond to security incidents to minimize impact." },
      { icon: "bi-camera-video", title: "Video Surveillance & Monitoring", desc: "Real-time monitoring solutions to enhance physical security." },
      { icon: "bi-person-badge", title: "Identity & Access Management", desc: "Ensure only authorized personnel access critical systems and data." },
    ],
    commitmentTitle: "Our Commitment to Delivering Reliable Network and Security Solutions",
    commitmentItems: [
      { title: "Proven Expertise", desc: "Trusted by businesses for robust network and security solutions." },
      { title: "Advanced Security Tools", desc: "Leverage AI-driven tools and analytics to stay ahead of threats." },
      { title: "Regulatory Compliance", desc: "Ensure compliance with industry regulations and standards." },
      { title: "Round-the-Clock Protection", desc: "24/7 security monitoring and support to safeguard your business." },
    ],
    image: "network-and-security.png",
  },
  {
    slug: "networking-solution",
    icon: "bi-hdd-network",
    title: "Collaboration and IoT",
    desc: "Connect your workforce and devices seamlessly. We build secure and reliable networks, integrate IoT solutions, and deploy collaboration tools for enhanced productivity.",
    longDesc: "Connect your workforce and devices seamlessly. We build secure and reliable networks, integrate IoT solutions, and deploy collaboration tools for enhanced productivity.",
    subtitle: "Connect your workforce and devices seamlessly.",
    introParagraphs: [
      "Connect your workforce and devices seamlessly. We build secure and reliable networks, integrate IoT solutions, and deploy collaboration tools for enhanced productivity.",
      "From enterprise networking and IoT integration to unified communication platforms, we help teams stay connected and operations stay smart.",
    ],
    features: [
      { icon: "bi-wifi", title: "Enterprise Networking", desc: "Deploy switching, routing, SD-WAN, and wireless networks built for performance and reliability." },
      { icon: "bi-cpu", title: "IoT Integration", desc: "Connect and manage smart devices, sensors, and industrial automation across your environment." },
      { icon: "bi-telephone-fill", title: "Unified Communication", desc: "Enable collaboration with VoIP, video conferencing, Microsoft Teams, and Zoom integrations." },
      { icon: "bi-camera-video", title: "Smart Surveillance", desc: "Deploy intelligent monitoring and AI-powered security for connected environments." },
      { icon: "bi-graph-up-arrow", title: "Network Monitoring", desc: "Proactively monitor your network to detect and resolve issues before they affect operations." },
      { icon: "bi-shield-check", title: "Secure Connectivity", desc: "Protect connected systems with segmentation, access control, and threat prevention." },
    ],
    commitmentTitle: "Our Commitment to Delivering Connected Collaboration and IoT Solutions",
    commitmentItems: [
      { title: "Certified Networking Professionals", desc: "Leverage the expertise of a highly skilled team of network and IoT engineers." },
      { title: "Reliable Infrastructure", desc: "Build robust, high-performance, and stable connected systems for your business." },
      { title: "Scalable Solutions", desc: "Future-proof your network and IoT deployments to meet evolving demands." },
      { title: "24/7 Monitoring & Support", desc: "Round-the-clock support to ensure uninterrupted operations." },
    ],
    image: "iot.png",
  },
  {
    slug: "ai-iot-solutions",
    icon: "bi-cpu",
    title: "Automation, AI & Analytics",
    desc: "Drive efficiency and gain valuable insights. We automate processes and implement analytics solutions to support data-driven decision making.",
    longDesc: "Drive efficiency and gain valuable insights. We automate processes and implement analytics solutions to support data-driven decision making.",
    subtitle: "Drive efficiency and gain valuable insights.",
    introParagraphs: [
      "Drive efficiency and gain valuable insights. We automate processes and implement analytics solutions to support data-driven decision making.",
      "From AI-powered analytics and workflow automation to business intelligence dashboards, we help you turn data into actionable outcomes.",
    ],
    features: [
      { icon: "bi-graph-up-arrow", title: "AI-Powered Analytics", desc: "Utilize AI to analyze vast amounts of data and generate actionable insights for your business." },
      { icon: "bi-gear-wide-connected", title: "Process Automation", desc: "Automate routine tasks and optimize operational efficiency with intelligent automation solutions." },
      { icon: "bi-bar-chart-line", title: "Business Intelligence", desc: "Implement Power BI, Tableau, and custom dashboards for smarter decision making." },
      { icon: "bi-cpu", title: "IoT & Edge Analytics", desc: "Collect and analyze data from connected devices and edge environments in real time." },
      { icon: "bi-shield-lock", title: "Smart Security", desc: "Protect connected systems with advanced AI-driven security and monitoring." },
      { icon: "bi-arrow-up-circle", title: "Scalable Solutions", desc: "Our solutions are designed to scale with your business, ensuring long-term growth and flexibility." },
    ],
    commitmentTitle: "Our Commitment to Transforming Your Business with Automation, AI & Analytics",
    commitmentItems: [
      { title: "Expert AI & Analytics Professionals", desc: "Our team ensures the successful deployment of automation and analytics solutions tailored to your needs." },
      { title: "Seamless Integration", desc: "Connect AI, automation, and analytics tools with your existing IT ecosystem." },
      { title: "Reliable Data Pipelines", desc: "Build robust data flows that support accurate reporting and real-time insights." },
      { title: "Continuous Monitoring", desc: "Ensure optimal performance with continuous monitoring and AI-driven analytics." },
      { title: "Scalable Implementations", desc: "Scale from pilot projects to enterprise-wide automation and analytics programs." },
    ],
    image: "automation-ai-analytics.png",
  },
  {
    slug: "software-solutions",
    icon: "bi-headset",
    title: "Professional & Managed Services",
    desc: "Focus on your core business while we manage your IT. Our expert team provides proactive support, maintenance, and 24/7 monitoring.",
    longDesc: "Focus on your core business while we manage your IT. Our expert team provides proactive support, maintenance, and 24/7 monitoring.",
    subtitle: "Focus on your core business while we manage your IT.",
    introParagraphs: [
      "Focus on your core business while we manage your IT. Our expert team provides proactive support, maintenance, and 24/7 monitoring.",
      "From end-to-end IT support and infrastructure management to outsourcing and consulting, we deliver SLA-driven services that keep your operations running smoothly.",
    ],
    features: [
      { icon: "bi-headset", title: "End-to-End IT Support", desc: "Proactive help desk, incident management, and IT operations support for your teams." },
      { icon: "bi-cloud-check", title: "Infrastructure Management", desc: "Monitor, maintain, and optimize your servers, cloud, and network environments." },
      { icon: "bi-laptop", title: "Device & Endpoint Management", desc: "Manage workstations, endpoints, and endpoint security across your organization." },
      { icon: "bi-graph-up", title: "SLA-Based Monitoring", desc: "24/7 monitoring with defined service levels to maximize uptime and performance." },
      { icon: "bi-people", title: "IT Outsourcing", desc: "Extend your IT capacity with dedicated managed services and expert resources." },
      { icon: "bi-briefcase", title: "IT Consulting & Integration", desc: "ITSM, ITIL-based consulting, and system integration aligned to business goals." },
    ],
    commitmentTitle: "Our Commitment to Delivering Reliable Professional & Managed Services",
    commitmentItems: [
      { title: "Experienced IT Professionals", desc: "Certified experts with deep experience in managed services and enterprise support." },
      { title: "Proactive Operations", desc: "Identify and resolve issues before they impact your business." },
      { title: "Defined SLAs", desc: "Clear service levels, reporting, and accountability you can rely on." },
      { title: "24/7 Support", desc: "Round-the-clock monitoring and assistance for critical IT environments." },
      { title: "Flexible Engagement Models", desc: "Services tailored to your size, industry, and operational needs." },
    ],
    image: "professional-managed-services.png",
  },
];

// Services page (/services) - 6 service categories; image = filename in public/img/services/
export const servicesPageContent = [
  { title: "Cloud Service", desc: "Maximize your cloud investments with our CloudOps services. We ensure efficient management, scalability, and cost-effectiveness for your cloud infrastructure.", slug: "cloud-solution", image: "cloud-services.png", tags: ["CloudOps", "Scalability", "Cost Optimization"] },
  { title: "Datacentre & Virtualization", desc: "Modernize your infrastructure with our data centre and virtualization expertise. We design, implement, and manage scalable, high-performance environments tailored to your business needs.", slug: "storage-virtualization", image: "datacentre-virtualisation.png", tags: ["Infrastructure Design", "Virtualization", "High Performance"] },
  { title: "Network and Security Services", desc: "Protect your business from evolving cyber threats. Our security solutions include assessments, threat detection, and mitigation strategies to safeguard your data.", slug: "cybersecurity-solution", image: "network-and-security.png", tags: ["Threat Detection", "Security Assessment", "Data Protection"] },
  { title: "Collaboration and IoT", desc: "Connect your workforce and devices seamlessly. We build secure and reliable networks, integrate IoT solutions, and deploy collaboration tools for enhanced productivity.", slug: "networking-solution", image: "iot.png", tags: ["Secure Networks", "IoT Integration", "Collaboration Tools"] },
  { title: "Automation, AI & Analytics", desc: "Drive efficiency and gain valuable insights. We automate processes and implement analytics solutions to support data-driven decision making.", slug: "ai-iot-solutions", image: "automation-ai-analytics.png", tags: ["Process Automation", "AI Solutions", "Data Analytics"] },
  { title: "Professional & Managed Services", desc: "Focus on your core business while we manage your IT. Our expert team provides proactive support, maintenance, and 24/7 monitoring.", slug: "software-solutions", image: "professional-managed-services.png", tags: ["24/7 Monitoring", "Proactive Support", "IT Maintenance"] },
];

export function getSolutionBySlug(slug) {
  return services.find((s) => s.slug === slug);
}

export const aboutPageStats = [
  { value: 50, suffix: "+", label: "Certified Engineers" },
  { value: 500, suffix: "+", label: "Industry Certifications Held" },
  { value: 400, suffix: "+", label: "Enterprise Clients" },
  { value: 15, suffix: "+", label: "Years in Industry" },
];

export const companyImpactStats = aboutPageStats;

const homeStatIcons = {
  "Certified Engineers": "bi-people-fill",
  "Industry Certifications Held": "bi-award-fill",
  "Enterprise Clients": "bi-building-fill",
  "Years in Industry": "bi-calendar-check",
};

/** Same counters as About page, with icons for home stat cards. */
export const homeStats = aboutPageStats.map((stat) => ({
  ...stat,
  icon: homeStatIcons[stat.label],
}));

export const homeFaqItems = [
  {
    q: "What IT solutions does Emicron offer?",
    a: "We offer end-to-end IT solutions including networking, cybersecurity, cloud, storage & virtualization, software development, and AI & IoT. From design to implementation and managed services, we cover your complete IT needs.",
  },
  {
    q: "Do you provide 24/7 support?",
    a: "Yes. Our managed services and professional support include proactive monitoring and round-the-clock assistance to ensure your systems run smoothly and issues are resolved quickly.",
  },
  {
    q: "How can I get a consultation?",
    a: "You can reach us via the Contact page, call us at 011-47593526, or email info@emicrontech.com. We respond to all inquiries within 24 hours on business days.",
  },
  {
    q: "Do you work with enterprises only?",
    a: "We serve businesses of all sizes—from startups to large enterprises. Our solutions are scalable and tailored to your requirements and budget.",
  },
];

export const aboutHighlightStat = { value: 20, suffix: "+", label: "Years of Delivering Excellence" };

// Home hero background slideshow from public/img/home-slider/
export const heroBackgroundSlides = [
  "/img/home-slider/1.png",
  "/img/home-slider/2.jpg",
  "/img/home-slider/3.jpg",
  "/img/home-slider/4.png",
];
export const HERO_SLIDE_INTERVAL_MS = 3500;

export const partners = ["Cisco", "HP Enterprise", "Dell EMC", "Microsoft", "VMware", "NetApp", "Fortinet", "Juniper", "Nutanix", "IBM"];

// Partner logos for home page "Authorized Partners" – { folder, file } from public/img/<folder>/
export const homePartnerLogos = [
  { folder: "cybersecurity", file: "1.png" }, { folder: "cybersecurity", file: "2.png" },
  { folder: "enterprise-networking", file: "1.png" }, { folder: "enterprise-networking", file: "2.png" },
  { folder: "infrastructure-solutions", file: "1.png" }, { folder: "infrastructure-solutions", file: "2.png" },
  { folder: "software-solutions", file: "1.png" }, { folder: "cloud-service", file: "1.png" },
  { folder: "computing", file: "1.png" }, { folder: "cctv", file: "1.png" },
  { folder: "antivirus", file: "1.png" }, { folder: "business-analytics", file: "1.jpg" },
  { folder: "backup", file: "1.png" }, { folder: "data-security", file: "1.png" },
  { folder: "audio-video-conferencing-solutions", file: "1.png" }, { folder: "online-UPS", file: "1.png" },
];

export { partnerCategories } from "./partnerCategories";

const partnerHoverTemplates = [
  (label) => `Certified ${label} partner delivering enterprise integration and support.`,
  (label) => `Authorized ${label} alliance for secure scalable business solutions.`,
  (label) => `Strategic ${label} collaboration enabling trusted digital transformation.`,
  (label) => `Premier ${label} vendor partnership for modern infrastructure needs.`,
  (label) => `Trusted ${label} technology partner for end to end deployments.`,
];

/** ~8–10 word hover blurb for partner logo popup */
export function getPartnerHoverText(categoryLabel, index = 0) {
  return partnerHoverTemplates[index % partnerHoverTemplates.length](categoryLabel);
}

/** Logo entry: filename string or { name, file?, line1, line2, hoverText } */
export function getPartnerLogoInfo(logo, categoryLabel, index = 0) {
  if (typeof logo === "string") {
    return {
      file: logo,
      name: categoryLabel,
      line1: categoryLabel,
      line2: "Authorized Partner",
      hoverText: getPartnerHoverText(categoryLabel, index),
    };
  }
  const name = logo.name ?? categoryLabel;
  return {
    file: logo.file ?? null,
    name,
    line1: logo.line1 ?? name,
    line2: logo.line2 ?? "Authorized Partner",
    hoverText: logo.hoverText ?? `Authorized ${name} partner for ${categoryLabel} solutions.`,
  };
}

export const customers = ["Tata Group", "Infosys", "HDFC Bank", "Maruti Suzuki", "AIIMS Delhi", "DRDO", "Wipro", "Bharti Airtel", "NTPC", "HCL Tech"];

// Customer logo filenames from public/img/customers-logo/
export const customerLogos = [
  "Allen_Logo.80bb3ed5f4e6a66262a7.jpg",
  "Apollo_Hospitals_Logo.svg.09c930cf93ed3e4b531a.png",
  "Bharti_Airtel-Logo.b443cccfc5eac833e467.png",
  "G&D_Logo.122c33595a902e2e6215.png",
  "General Electric_logo.63bf128a8bc967c2e138.png",
  "Godfrey_phillips_logo.f27dda0fa4ac93ac804c.png",
  "IIM_Logo_college.70531ffdcd63eadac40a.png",
  "Ingersoll_Rand_logo.968d538d67a054384d7c.png",
  "Jamia_Logo_college.59a1965461d0032f1f0b.png",
  "Physics wallah_logo.11c29c900b6d2a327f8a.jpg",
  "Punjab police logo.fcee67a224fcec9c0b3a.jpeg",
  "Religare-Logo.9a732afa07ee0ccf8941.jpg",
  "TCIL_Logo.a12b91f4490b122c496a.jpeg",
  "Yotta-Logo-on-white-Bg.ae0a5cd69e1cf7179035.png",
  "download (1).jpeg",
  "download (1).png",
  "download (10).png",
  "download (11).png",
  "download (2).jpeg",
  "download (2).png",
  "download (3).jpeg",
  "download (3).png",
  "download (4).png",
  "download (5).png",
  "download (6).png",
  "download (7).png",
  "download (8).png",
  "download (9).png",
  "download.jpeg",
  "download.png",
  "gmr logo.5ebdb3d6bb73a65b4f08.jpg",
  "indigrid logo.50d3abfa2633588bcdf1.png",
  "image.png",
  "image copy 2.png",
  "image copy 3.png",
  "image copy 4.png",
];
